import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { SubPageHeader } from '../pages/components/subPageHeader';
export const FullScreenModalContainer = ({ title, children }) => {
    const containerCss = css `
    display: fixed;
    width: 100%;
    height: 100%;
  `;
    const rowCss = css `
    display: flex;
    flex-direction: column;
    width: 100%;
  `;
    const contentsCss = css `
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    overflow: auto;
    align-items: center;
    color: white;
    padding: 20px;
  `;
    return (_jsx("div", { css: containerCss, children: _jsxs("div", { css: rowCss, children: [_jsx(SubPageHeader, { title: title, omitExtraButtons: true, omitHomeLink: true }), _jsx("div", { css: contentsCss, children: children })] }) }));
};
